var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGreycheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M3.10334029,7.96762325 C2.96555324,7.8263429 2.96555324,7.59087564 3.10334029,7.44959529 L3.6085595,6.93156733 C3.74634656,6.79028698 3.97599165,6.79028698 4.11377871,6.93156733 L6.96137787,9.87490802 C7.05323591,9.96909492 7.21398747,9.96909492 7.30584551,9.87490802 L12.8862213,4.10596026 C13.0240084,3.96467991 13.2536534,3.96467991 13.3914405,4.10596026 L13.8966597,4.62398823 C14.0344468,4.76526858 14.0344468,5.00073584 13.8966597,5.14201619 L7.39770355,11.8763797 C7.25991649,12.0412068 7.0302714,12.0412068 6.89248434,11.8763797 L3.10334029,7.96762325 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#005082"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#CBCBCB",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    mask: "url(#d)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreycheckbox);
export default __webpack_public_path__ + "static/media/icon_greycheckbox.159f2483e12b5c6045976b3574bad629.svg";
export { ForwardRef as ReactComponent };